export enum AppRoutes {
  DEFAULT_EMPTY = '',
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot-password',
  SELLER_PORTAL = 'seller-portal',
  ORDERS = 'order-list',
  ORDER_DETAIL = 'order-detail',
  HISTORICAL = 'historical-orders',
  HISTORIC_ORDER_DETAIL = 'order-historic-detail',
  CREATE_NEW_PASSWORD = 'create-new-password',
  SELLER_DRIVE = 'seller-drive',
  DASHBOARD = 'dashboard',
  CLIENTS = 'clients',
  CLIENT_DETAIL = 'client-detail',
}
